module.exports = __webpack_public_path__ + "pisek0-4-betonak-prany.jpg?0cb72eeebcc4a7db33028d590f55203b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/pisek0-4-betonak-prany.jpg
// module id = 72
// module chunks = 0